import config from '@config'
import useABTestValue from '@hooks/useABTestValue'

export type UseIsThemeSwitcherEnabled = () => boolean

const {
  backend: { teamcityEnv },
} = config

const useIsThemeSwitcherEnabled: UseIsThemeSwitcherEnabled = () =>
  useABTestValue('showThemeSwitcher') === 'show' ||
  !['prod'].includes(teamcityEnv)

export default useIsThemeSwitcherEnabled
